import { Component, OnInit } from '@angular/core';
import { ModalBase } from 'curvy';

type InType = {
	title: string;

	orders: Array<{
		order_id: number,
		title: string,
		date: string
	}>;

	message?: {
		message: string;
		icon: string;
		iconColor: string;
	};
};

@Component({
	selector: 'task-order-links-dialog',
	template: `
		<h2 class="modal-title">{{ injectedData.title | trans }}</h2>

		<div class="flex-row align-center" *ngIf="injectedData.message">
			<i class="large flex-auto"
				[attr.icon]="injectedData.message.icon"
				[knwStyle]="{
					color: injectedData.message.iconColor
				}"
			></i>
			<div class="flex-dynamic" style="flex: 12; white-space: pre-line">
				{{injectedData.message.message}}
			</div>
		</div>

		<div>
			@for (order of injectedData.orders; track order.order_id) {
				<div class="flex-row" style="margin-top: 0.25em">
					<a href="{{'/orders/'+order.order_id}}"
						target="_blank"
						style="cursor: pointer; margin-right: 1ch"
					>
						<span class="truncate-text" style="vertical-align: middle">
							#{{ order.order_id }}
						</span>
					</a>

					<span style="color: rgb(var(--primary)); text-align: left">
						<span class="truncate-text">{{order.title}}</span>
					</span>

					<div class="flex-dynamic"></div>

					<span style="color: rgb(var(--primary)); text-align: left">
						<span class="truncate-text">{{order.date | datefmt : 'short_date'}}</span>
					</span>
				</div>
			}
		</div>

		<div class="flex-row modal-footer">
			<button color="primary"
				(click)="done()"
			>
				<i icon="arrow_back"></i>
				{{ "OK" | trans }}
			</button>
		</div>
	`
})
export class OrderLinksDialog extends ModalBase<InType, null> {
	preventSoftClose = true;

	sorted() {
		return [...this.injectedData.orders].sort((a, b) => {
			return a.date.localeCompare(b.date);
		});
	}

	done() {
		this.submit(null);
	}
}
